import {createSlice} from "@reduxjs/toolkit";
import {getRol, addRol, updateRol, deleteRol} from "./thunks";


export const initialState: any = {
    rolLists: [],
    error: {},
};


const RolSlice = createSlice({
    name: 'RolSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        //Get Rol
        builder.addCase(getRol.fulfilled, (state: any, action: any) => {
            state.rolLists = action.payload.data;
        });
        builder.addCase(getRol.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });

        //Add Rol
        builder.addCase(addRol.fulfilled, (state: any, action: any) => {
            state.rolLists = [...state.rolLists, action.payload];
        });

        builder.addCase(addRol.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });
        //UpdateRol

        builder.addCase(updateRol.fulfilled, (state: any, action: any) => {
            state.rolLists = state.rolLists.map((rol: any) =>
                rol.id === action.payload.id
                    ? {...rol, ...action.meta.arg}
                    : rol
            );
        });

        builder.addCase(updateRol.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });

        //Delete Rol
        builder.addCase(deleteRol.fulfilled, (state: any, action: any) => {

            state.rolLists = (state.rolLists || []).filter((product: any) => product.id !== action.payload.id);
        })
        builder.addCase(deleteRol.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;

        });

    }
});

export default RolSlice.reducer;
